import { render } from "./PythonLogo.vue?vue&type=template&id=90bb36a2"
import script from "./PythonLogo.vue?vue&type=script&lang=js"
export * from "./PythonLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__